import { render, staticRenderFns } from "./EditPart.vue?vue&type=template&id=cadc33ee&scoped=true"
import script from "./EditPart.vue?vue&type=script&lang=ts"
export * from "./EditPart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadc33ee",
  null
  
)

export default component.exports